import { render, staticRenderFns } from "./DraftPriceRouteDistrictBase.vue?vue&type=template&id=dabc5572&"
import script from "./DraftPriceRouteDistrictBase.vue?vue&type=script&lang=js&"
export * from "./DraftPriceRouteDistrictBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports